import { Component, Input } from '@angular/core';

/** The emblem's artwork aspect: the "AGU" letters span x 0–93.8 of the 176×36 lockup. */
const LOGO_VIEWBOX_WIDTH = 94;
const LOGO_VIEWBOX_HEIGHT = 36;

/**
 * The AGU mark, inlined so it is painted by `currentColor` — set a colour token
 * on the host (the sidebar uses `--mj-brand-primary`) and the mark follows it.
 * Replaces the Sep 1 mockup's three-bar brand (designer checklist 2026-10-24,
 * "Update Logo to AGU"). It is its own component rather than an `agu-icon`
 * registry entry: that registry is stroke-only by design (`fill-opacity: 0`).
 *
 * EMBLEM ONLY: the file's full lockup carries the "ADVANCING EARTH AND SPACE
 * SCIENCES" tagline, which at a 24px brand-row height is unreadable and, at
 * 117px wide, overflowed the 250px rail and clipped the wordmark (measured live
 * 2026-10-24: brand scrollWidth 268 vs 197). The seven letter paths (62.7px at
 * 24px) are what a sidebar lockup needs; nothing else uses the mark yet (YAGNI).
 */
@Component({
    standalone: false,
    selector: 'agu-logo',
    templateUrl: './logo.component.html',
    styleUrl: './logo.component.scss',
    host: { class: 'agu-logo' },
})
export class AGULogoComponent {
    /** Rendered height in px; the width follows the artwork's aspect. */
    @Input() Height = 24;

    get Width(): number {
        return (this.Height * LOGO_VIEWBOX_WIDTH) / LOGO_VIEWBOX_HEIGHT;
    }
}
